const locale = navigator.language || navigator.userLanguage;

export const geittext = locale === 'fr-FR' ?
    {
        pcstate: "Etat des PC",
        pctype: "Type de PC",
        desktop: "PC Fixe",
        laptop: "PC Portable",
        actives: "Actifs",
        inactives: "Inactifs",
        saver: "Saver",
        viewer: "Viewer",
        pclist: "Liste des PC",
        displayonlylap: "N'afficher que les PC portables",
        displayonlydesk: "N'afficher que les PC fixes",
        selectedpclength: "Nombre de PC sélectionnés",
        indicators: "Indicateurs",
        indiclessoneyear: "< 1 an",
        indiclesssixmonths: "< 6 mois",
        indiclessthreemonths: "< 3 mois",
        indiclessonemonth: "< 1 mois",
        indiclessoneweek: "< 1 semaine",
        indiclessoneday: "< 1 jour",
        indicallcount: "Tous",
    }
    :
    {
        pcstate: "PC states",
        pctype: "PC types",
        desktop: "Desktop",
        laptop: "Laptop",
        actives: "Actives",
        inactives: "Inactives",
        saver: "Saver",
        viewer: "Viewer",
        pclist: "PC list",
        displayonlylap: "Only display desktops",
        displayonlydesk: "Only display laptops",
        selectedpclength: "PC selected",
        indicators: "Indicators",
        indiclessoneyear: "< 1 year",
        indiclesssixmonths: "< 6 months",
        indiclessthreemonths: "< 3 months",
        indiclessonemonth: "< 1 month",
        indiclessoneweek: "< 1 week",
        indiclessoneday: "< 1 day",
        indicallcount: "All",
    }
